import axios from 'axios'
import AppApiResponse from "./AppApiResponse";

const instance = axios.create({
  timeout: 5000,
  headers: {
    'content-type': 'application/json'
  }
})

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
instance.interceptors.response.use(function (response) {
  // Do something with response data
  let apiResponse = new AppApiResponse(response)
  if (apiResponse.isSuccess()) {
    return Promise.resolve(apiResponse)
  } else {
    return Promise.reject(apiResponse)
  }
}, function (error) {
  let apiResponse = new AppApiResponse(error)
  // if (error.response) {
  //   // Do something with response error
  //   if (error.response.status === 422 ||
  //     error.response.status === 429) {
  //     return Promise.resolve(apiResponse)
  //   }
  // }
  return Promise.reject(apiResponse)
})

let apiTokenMeta = document.querySelector(`meta[name='api-token']`)
if (apiTokenMeta && apiTokenMeta.content.length > 0) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + apiTokenMeta.content
}
export default instance



// WEBPACK FOOTER //
// ./resources/assets/js/app-axios.js